import Api from '../Api';

class CharityTypesApi extends Api {
  constructor() {
    super('charities/types', 'charitytypes');
  }
}
const charityTypesApi = new CharityTypesApi();
export default charityTypesApi;
